import React from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import moment from "moment";
import "./HistoryModal.less";
import { toDisplayFormatWithTime } from "../../../lib/utils/formatDate";
import rtkRequestStatusCodes from "../../../lib/const/rtkRequestStatusCodes";
import { checkIsLoaded } from "../../../lib/utils/checkLoadingStatus";

const HistoryModal = () => {
  const { actionType } = useSelector((state) => state.rtkDictionaries);
  const { billActionHistory, billActionHistoryLoading, uniqUsers } = useSelector(
    (state) => state.properties
  );

  const modalDataHistory =
    checkIsLoaded(billActionHistoryLoading) &&
    billActionHistory.map((item) => {
      const actionName =
        actionType && actionType.find((type) => type?.id === item.actionTypeId)?.name;
      const userLogin = uniqUsers && uniqUsers.find((user) => user?.userId === item.userId)?.login;
      return {
        key: item.id,
        actionDate: item.actionDate ? toDisplayFormatWithTime(item.actionDate) : "",
        actionTypeId: actionName,
        login: userLogin,
        dsc: item.dsc,
      };
    });

  const columnsModalHistory = [
    {
      title: "Дата",
      dataIndex: "actionDate",
      key: "actionDate",
      defaultSortOrder: "descend",
      sorter: (a, b) =>
        moment(a.actionDate, "DD.MM.YYYY HH:mm:ss.SSS").unix() -
        moment(b.actionDate, "DD.MM.YYYY HH:mm:ss.SSS").unix(),
    },
    {
      title: "Операция",
      dataIndex: "actionTypeId",
      key: "actionTypeId",
    },
    {
      title: "Инициатор",
      dataIndex: "login",
      key: "login",
    },
    {
      title: "Комментарий",
      dataIndex: "dsc",
      key: "dsc",
    },
  ];

  return (
    <>
      <Table
        loading={billActionHistoryLoading === rtkRequestStatusCodes.pending}
        columns={columnsModalHistory}
        dataSource={modalDataHistory}
        pagination={false}
        scroll={{ y: 400 }}
        className="bill-history-table"
      />
    </>
  );
};

export default HistoryModal;
